import { RefObject, useEffect, useState } from "react";

export const useScrollShadows = (ref: RefObject<HTMLDivElement>) => {
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateShadows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = element;

      // Show left shadow if scrolled right from start
      setShowLeftShadow(scrollLeft > 0);

      // Show right shadow if not scrolled to end
      setShowRightShadow(scrollLeft < scrollWidth - clientWidth - 1);
    };

    // Initial check
    updateShadows();

    // Listen for scroll events
    element.addEventListener("scroll", updateShadows);

    // Listen for resize events
    window.addEventListener("resize", updateShadows);

    return () => {
      element.removeEventListener("scroll", updateShadows);
      window.removeEventListener("resize", updateShadows);
    };
  }, [ref]);

  return { showLeftShadow, showRightShadow };
};
